import { render } from "./DivisionLeadersThurB.vue?vue&type=template&id=34bf9cf8&scoped=true"
import script from "./DivisionLeadersThurB.vue?vue&type=script&scoped=true&lang=js"
export * from "./DivisionLeadersThurB.vue?vue&type=script&scoped=true&lang=js"

import "./DivisionLeadersThurB.vue?vue&type=style&index=0&id=34bf9cf8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bf9cf8"]])

export default __exports__